/**
 * @fileoverview Pure workflow-step reorder model extracted from
 * WorkflowEditor.tsx (test-coverage Task 23, fix round 1). No React, no
 * dnd-kit event types — just the same findIndex/findIndex/arrayMove guard
 * chain `computeReorderedIds` uses in
 * `src/components/settings/reports/reportSectionModel.ts`, generalised to
 * operate on draft items keyed by `localKey` instead of a bare id list.
 */
import { arrayMove } from "@dnd-kit/sortable";

/** The reordered item list for a dnd-kit drag-end, or `null` when the drag
 *  didn't move anything (dropped on itself, dropped outside a droppable, or
 *  either key is no longer present). Same guard order as
 *  `computeReorderedIds`. */
export function computeReorderedItems<T extends { localKey: string }>(
  items: T[],
  activeKey: string,
  overKey: string | null | undefined,
): T[] | null {
  if (!overKey || activeKey === overKey) return null;
  const from = items.findIndex((it) => it.localKey === activeKey);
  const to = items.findIndex((it) => it.localKey === overKey);
  if (from === -1 || to === -1) return null;
  return arrayMove(items, from, to);
}
